import { createInitialLocalizationState } from './seed';
import { LocalizationState } from './types';

const storageKey = 'localization-control-plane-state-v1';

export function loadState(): LocalizationState {
  if (typeof window === 'undefined') return createInitialLocalizationState();
  const saved = window.localStorage.getItem(storageKey);
  if (!saved) return createInitialLocalizationState();
  try {
    return JSON.parse(saved) as LocalizationState;
  } catch {
    return createInitialLocalizationState();
  }
}

export function saveState(state: LocalizationState): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(storageKey, JSON.stringify(state));
  }
}

export function resetState(): LocalizationState {
  const state = createInitialLocalizationState();
  saveState(state);
  return state;
}
